import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Martín González',
  location: 'Buenos Aires, CABA',
  text: 'Nunca pude ser constante con mis gastos hasta que probé esta plantilla. Es súper intuitiva y el hecho de que sea en Google Sheets me permite verla desde el celu cuando estoy en la calle. Un 10.',
  rating: 5
}, {
  name: 'Sofía Rodríguez',
  location: 'Córdoba Capital',
  text: "Estaba llena de deudas y no sabía por dónde empezar. El método de 'bola de nieve' que explican en el video tutorial me cambió la cabeza. En 3 meses ya cancelé dos tarjetas.",
  rating: 5
}, {
  name: 'Lucas Martínez',
  location: 'Rosario, Santa Fe',
  text: 'Lo que más me gusta es que no es complicada. Probé apps que te piden vincular el banco y me daban desconfianza. Esto es simple, seguro y lo controlo yo. Recomendadísima.',
  rating: 5
}];
export function Testimonials() {
  return <section className="py-10 md:py-20 bg-white" data-id="element-199">
      <div className="container mx-auto px-4 md:px-6" data-id="element-200">
        <div className="text-center mb-6 md:mb-12" data-id="element-201">
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-2 md:mb-4" data-id="element-202">
            Lo que dicen quienes ya tomaron el control
          </h2>
          <p className="text-sm md:text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-203">
            Más de 1.000 personas ya están ordenando sus finanzas con nuestra
            plantilla.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-204">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-gray-50 p-4 md:p-8 rounded-2xl relative border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-205">
              <Quote className="absolute top-3 right-3 md:top-6 md:right-6 w-6 h-6 md:w-8 md:h-8 text-teal-600/10" data-id="element-206" />

              <div className="flex gap-1 mb-2 md:mb-4" data-id="element-207">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 md:w-5 md:h-5 fill-amber-400 text-amber-400" data-id="element-208" />)}
              </div>

              <p className="text-sm md:text-base text-gray-700 mb-3 md:mb-6 leading-relaxed" data-id="element-209">
                "{testimonial.text}"
              </p>

              <div className="flex items-center gap-2 md:gap-3" data-id="element-210">
                <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-teal-50 flex items-center justify-center text-teal-600 font-bold text-base md:text-lg" data-id="element-211">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-212">
                  <h4 className="font-bold text-gray-900 text-xs md:text-sm" data-id="element-213">
                    {testimonial.name}
                  </h4>
                  <p className="text-[10px] md:text-xs text-gray-500" data-id="element-214">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}